import HeaderSponsored from '../../headerSponsored';
import './headerCardTenis.sass';

/**
 * Renderiza el encabezado de una tarjeta de evento de tenis,
 * mostrando la liga y el estado del juego (en vivo, finalizado, próximo, error).
*/
export default function HeaderCardTenis({ data, indexJson  }) {
  return (
    <HeaderSponsored data={data} prefixClass="card-tenis" indexJson={indexJson}/>
  )
}